export default "__VITE_ASSET__CinsCmuL__"